import React, { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import { DepartmentSupplyDetailEntity, DepartmentSupplyFormValueEntity } from '../../../../interface/department-supply';
import { ModuleEntity, PaginateReqEntity, PaginateRespEntity } from '../../../../interface';
import { IsNullOrEmptyArray, IsStringNullEmptyOrUndefined } from '../../../../utils/null-check';
import { toast } from 'react-toastify';
import { searchInputPlaceholder, toastOptObj } from '../../../../utils/constants';
import { APIToCreateOrUpdateDepartmentSupply, APIToDeleteDepartmentSupply, APIToExportDepartmentSupply, APIToGetDepartmentSupplyDetail } from '../../../../service/api-service';
import { ALPHABET_NUMBER_SPACE_PATTERN } from '../../../../utils/pattern';
import { checkActionAuthorization, checkValidInputOnKeyDown, downloadCsvFile, IsFormValid, removeSpaceOnFirstCharacter } from '../../../../service/shared.service';
import { APIResponseEntity } from '../../../../interface/api-responce';
import { AxiosResponse } from 'axios';
import DeleteConfirmationDialog from '../../../../components/delete-confirmation';
import Loader from '../../../../components/loader';
import { RadioButton } from 'primereact/radiobutton';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import PrimePaginator from '../../../../components/prime-paginator';
import { ProductionDepartmentEnumEntity } from '../../../../utils/enum';

const initialFormValues: DepartmentSupplyFormValueEntity = {
    supplyValue: "",
    status: "active"
};

declare var $: any;

const DepartmentSupplyPage = ({ type }: { type: ProductionDepartmentEnumEntity }) => {
    const navigate = useNavigate();

    const pageTypeMap: Record<ProductionDepartmentEnumEntity, string> = {
        [ProductionDepartmentEnumEntity.WHAT_TO_SUPPLY]: "What To Supply",
        [ProductionDepartmentEnumEntity.WHY_TO_SUPPLY]: "Why To Supply",
        [ProductionDepartmentEnumEntity.ACTION_REQUIRED]: "Action Required",
        [ProductionDepartmentEnumEntity.MASTER_ITEM]: "Master Item",
    };
    const pageExportTypeMap: Record<ProductionDepartmentEnumEntity, string> = {
        [ProductionDepartmentEnumEntity.WHAT_TO_SUPPLY]: "Access Export What To Supply",
        [ProductionDepartmentEnumEntity.WHY_TO_SUPPLY]: "Access Export Why To Supply",
        [ProductionDepartmentEnumEntity.ACTION_REQUIRED]: "Access Export Action Required",
        [ProductionDepartmentEnumEntity.MASTER_ITEM]: "Access Export Master Item",
    };

    const pageType = pageTypeMap[type] || "";

    const exportPermission = pageExportTypeMap[type] || "";

    const [formValues, setFormValues] = useState(initialFormValues);
    const [isEdit, setIsEdit] = useState<boolean>(false);
    const [updateId, setUpdateId] = useState<string>("");
    const [tableData, setTableData] = useState<DepartmentSupplyFormValueEntity[]>([]);
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const [isSubmitted, setIsSubmitted] = useState<boolean>(false);
    const [totalPageCount, setTotalPageCount] = useState<number>(0);
    const [search, setSearch] = useState<string>("");
    const [filterReq, setFilterReq] = useState<PaginateReqEntity>({
        pageNumber: 0,
        pageSize: 10,
        searchText: ""
    });
    const [errors, setErrors] = useState<{ supplyValue: string }>({
        supplyValue: "value is required"
    });

    const fetchDepartmentSupplyDetail = async () => {
        setIsLoading(true);
        const resp = await APIToGetDepartmentSupplyDetail(filterReq, type);
        setIsLoading(false);
        setTableData([]);
        setTotalPageCount(0);
        if (resp) {
            if (resp.data && resp.status === 200) {
                const axiosResp = resp.data;
                if (axiosResp && axiosResp.data && axiosResp.status && axiosResp.statusCode === 200) {
                    const paginateResp: PaginateRespEntity = axiosResp.data;
                    setTableData(paginateResp.data);
                    setTotalPageCount(paginateResp.totalCount);
                }
            } else {
                toast.error(
                    resp.data.message,
                    toastOptObj
                );
            }
        }
    }


    const onPageChange = (event: any) => {
        setFilterReq({
            ...filterReq,
            pageSize: event.rows,
            pageNumber: event.page
        });
    };

    const handleChange = (field: string, value: string): void => {
        setFormValues((prev) => ({
            ...prev,
            [field]: value
        }));

        switch (field) {
            case "supplyValue":
                const isValid: boolean = ALPHABET_NUMBER_SPACE_PATTERN.test(value);
                setErrors((prev) => ({
                    ...prev,
                    supplyValue: IsStringNullEmptyOrUndefined(value)
                        ? "Please enter value"
                        : (!isValid ? "Please enter valid value" : !IsStringNullEmptyOrUndefined(value)
                            && value.length >= 3 ? "" : "Minimum 3 characters are required")
                }));
                break;
        }
    };
    const handleSubmit = async (
        e: React.FormEvent<HTMLFormElement>
    ): Promise<void> => {
        e.preventDefault();
        setIsSubmitted(true);
        const isValid = IsFormValid(errors);
        if (!isValid) return;

        const formData = { supplyValue: formValues.supplyValue, type, isActive: String(formValues.status === "active") }
        try {
            setIsLoading(true);
            const resp = isEdit
                ? await APIToCreateOrUpdateDepartmentSupply(formData, updateId)
                : await APIToCreateOrUpdateDepartmentSupply(formData);
            setIsLoading(false);

            if (resp) {
                if (resp.data && (resp.status === 200 || resp.status === 201)) {
                    const axiosResp: APIResponseEntity = resp.data;
                    if (axiosResp && axiosResp.data && axiosResp.status &&
                        (axiosResp.statusCode === 200 || axiosResp.statusCode === 201)) {
                        toast.success(axiosResp.message, { ...toastOptObj });
                        handleClear();
                        setFilterReq({ ...filterReq, pageNumber: 0 });
                    } else {
                        toast.error(axiosResp.message, { ...toastOptObj });
                    }
                }
                else {
                    toast.error(resp.data.message, { ...toastOptObj });
                }
            }
        } catch (error) {
            console.log(error);
            setIsLoading(false);
            toast.error(
                "Something went wrong",
                {
                    ...toastOptObj
                }
            );
        }
    };
    const handleEdit = (
        rowData: DepartmentSupplyDetailEntity
    ): void => {
        setIsEdit(true);
        setUpdateId(rowData.id);
        setFormValues({
            supplyValue: rowData.supplyValue,
            status: rowData.isActive ? "active" : "inactive"
        });
        setErrors({
            supplyValue: ""
        });
    };
    const handleDelete = async (
        id: string
    ): Promise<void> => {
        setIsLoading(true);
        const resp = await APIToDeleteDepartmentSupply(id);
        setIsLoading(false);
        if (resp) {
            if (resp.data && resp.status === 200) {
                const axiosResp: APIResponseEntity = resp.data;
                if (axiosResp && axiosResp.data && axiosResp.status && axiosResp.statusCode === 200) {
                    toast.success(axiosResp.message, { ...toastOptObj });
                    handleClear();
                    setFilterReq({ ...filterReq, pageNumber: 0 });
                } else {
                    toast.error(axiosResp.message, { ...toastOptObj });
                }
            }
            else {
                toast.error(resp.data.message, { ...toastOptObj });
            }
        }
        setFilterReq((prev) => ({
            ...prev,
            pageNumber: 0
        }));
    };
    const handleClear = (): void => {
        setIsEdit(false);
        setUpdateId("");
        setFormValues(initialFormValues);
        setIsSubmitted(false);
        setErrors({
            supplyValue: "value is required"
        });
    };

    const handleExportDepartmentSupply = async (): Promise<void> => {
        setIsLoading(true);
        const resp: AxiosResponse<APIResponseEntity> = await APIToExportDepartmentSupply(type);
        setIsLoading(false);
        if (!resp || resp.status !== 200 || !resp.data)
            return;
        const apiResp = resp.data;
        if (apiResp.statusCode !== 200) {
            toast.error(
                apiResp.message,
                { ...toastOptObj }
            );
            return;
        }
        const excelUrl = apiResp.data.xlsxUrl;
        if (excelUrl) {
            const fileName = excelUrl.split("/").pop();
            if (fileName) {
                await downloadCsvFile(excelUrl, fileName);
            }
        }
    };
    const statusTemplate = (
        rowData: DepartmentSupplyDetailEntity
    ) => {
        return (
            <span
                className={`badge badge-${rowData.isActive
                    ? "success"
                    : "danger"
                    }`}
            >
                {rowData.isActive
                    ? "Active"
                    : "Inactive"}
            </span>
        );
    };
    const actionTemplate = (
        rowData: DepartmentSupplyDetailEntity
    ) => {
        return (
            <ul className="tableIcon d-flex cursor-pointer wrap-content" >
                {
                    checkActionAuthorization("update", pageType as ModuleEntity) &&
                    <li title="Edit"
                        onClick={() =>
                            handleEdit(rowData)
                        }
                    >
                        <img
                            src="/assets/images/edit-icon.svg"
                            alt="Edit"
                        />
                    </li>
                }
                {
                    checkActionAuthorization("delete", pageType as ModuleEntity) &&
                    <li title="Delete">
                        <DeleteConfirmationDialog
                            isAccepted={() =>
                                handleDelete(rowData.id)
                            }
                        />
                    </li>
                }
            </ul>
        );

    };



    useEffect(() => {
        fetchDepartmentSupplyDetail();
    }, [filterReq]);

    useEffect(() => {
        $("#id_of_searchbox").keyup((event: any) => {
            const searchText = IsStringNullEmptyOrUndefined(event.target.value)
                ? ""
                : event.target.value;

            if (
                event.keyCode === 13 &&
                (
                    IsStringNullEmptyOrUndefined(searchText) ||
                    searchText.length >= 3
                )
            ) {
                setFilterReq({
                    ...filterReq,
                    searchText,
                    pageNumber: 0
                });
            }
        });
    }, []);

    return (
        <>
            <Loader isLoading={isLoading} />

            <div className="content-wrapper">
                <div className="col-12">
                    <div className="row">
                        <div className="col-lg-4 col-md-4">
                            <div className="card card-rounded">
                                <div className="card-body">
                                    <h4 className="card-title mb-3">
                                        {pageType}
                                    </h4>
                                    {(checkActionAuthorization("create", pageType as ModuleEntity) || isEdit) ? (
                                        <form onSubmit={handleSubmit}>
                                            <div className="form-group mb-3">
                                                <label>
                                                    Value <sup className="mandatory">*</sup>
                                                </label>
                                                <input type="text" name='supplyValue'
                                                    className="form-control form-control-lg"
                                                    maxLength={30} value={formValues.supplyValue}
                                                    onChange={(e) => handleChange(e.target.name, e.target.value)}
                                                    onKeyDown={(event: any) => {
                                                        checkValidInputOnKeyDown(event, ALPHABET_NUMBER_SPACE_PATTERN);
                                                        removeSpaceOnFirstCharacter(event);
                                                    }}
                                                    placeholder="Enter Department"
                                                />
                                                {
                                                    isSubmitted
                                                    &&
                                                    <small className='text-danger font-weight-500'> {errors.supplyValue} </small>
                                                }
                                            </div>

                                            <div className="form-group">
                                                <label>STATUS</label>
                                                <div className='d-flex mb-2'>
                                                    <div key="active" className="d-flex align-items-center mb-2">
                                                        <RadioButton
                                                            inputId="active"
                                                            name="status"
                                                            className='me-2'
                                                            value="active"
                                                            onChange={(e) => handleChange("status", e.value)}
                                                            checked={formValues.status === "active"}
                                                        />
                                                        <label className='me-5'>Active</label>
                                                    </div>
                                                    <div key="inactive" className="d-flex align-items-center mb-2">
                                                        <RadioButton
                                                            inputId="inactive"
                                                            name="status"
                                                            className='me-2'
                                                            value="inactive"
                                                            onChange={(e) => handleChange("status", e.value)}
                                                            checked={formValues.status === "inactive"}
                                                        />
                                                        <label className='me-5'>Inactive</label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className='col-12'>
                                                <button type="submit" className="btn btn-block  btn-primary btn-md font-weight-medium m-0 me-2" >
                                                    {isEdit ? "Update" : "Save"} {pageType}
                                                </button>
                                                <button
                                                    type="button"
                                                    className="btn btn-cancel text-dark m-0"
                                                    onClick={() => isEdit ? handleClear() : navigate('/settings/production')}>
                                                    {isEdit ? 'Clear' : 'Cancel'}
                                                </button>
                                            </div>
                                        </form>
                                    ) : (
                                        <div className="alert alert-danger" role="alert">
                                            You don't have permission to create {pageType.toLocaleUpperCase()}
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-8 col-md-8">
                            <div className="card card-rounded">
                                <div className="card-body">
                                    <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">

                                        <div className="col-md-7 p-0">
                                            <div className="input-group search-grp">
                                                <img
                                                    src="/assets/images/search.svg"
                                                    alt="search"
                                                    className="input-group-text searchIptGrpTxt"
                                                />

                                                <input
                                                    type="text"
                                                    className="form-control form-control-lg searchInput"
                                                    id="id_of_searchbox"
                                                    placeholder={searchInputPlaceholder}
                                                    value={search}
                                                    onChange={(e) => setSearch(e.target.value)}
                                                />

                                                {!IsStringNullEmptyOrUndefined(search) && (
                                                    <button
                                                        className="btn btn-cancel text-dark search-button-clear"
                                                        type="button"
                                                        onClick={() => {
                                                            setSearch("");
                                                            setFilterReq({
                                                                ...filterReq,
                                                                searchText: "",
                                                                pageNumber: 1
                                                            });
                                                        }}
                                                    >
                                                        Clear
                                                    </button>
                                                )}
                                            </div>
                                        </div>

                                        {checkActionAuthorization(
                                            "upgrade",
                                            exportPermission as ModuleEntity
                                        ) && (
                                                <button
                                                    type="button"
                                                    className="btn btn-success"
                                                    onClick={handleExportDepartmentSupply}
                                                >
                                                    Export {pageType}
                                                </button>
                                            )}
                                    </div>
                                    <DataTable
                                        value={tableData}
                                        className="p-datatable-sm"
                                    >
                                        <Column
                                            field="supplyValue"
                                            header={pageType.toLocaleUpperCase()}
                                        />
                                        <Column
                                            header="STATUS"
                                            body={statusTemplate}
                                        />
                                        {(checkActionAuthorization("update", pageType as ModuleEntity) || checkActionAuthorization("delete", pageType as ModuleEntity)) &&
                                            <Column
                                                header="ACTION"
                                                body={actionTemplate}
                                            />}

                                    </DataTable>

                                </div>

                                {!IsNullOrEmptyArray(tableData) && (
                                    <PrimePaginator
                                        pageNumber={filterReq.pageNumber}
                                        pageSize={filterReq.pageSize}
                                        totalRecords={totalPageCount}
                                        onPageChange={onPageChange}
                                    />
                                )}

                            </div>

                        </div>

                    </div>
                </div>
            </div>
        </>
    )
}

export default DepartmentSupplyPage